<!-- 工效分析 -->
<template>
  <div class="main yy">
    <div class="BedInformationRecord" :id="BedInformation">
      <div class="BedInformation_box">
        <div class="BedInformation_title">
          <div class="BedInformation_title_">
            <div class="BedInformation_button" v-if="BedInformation">
							<CascadeSelector
								:data="cascadeData"
								:default-value="selectedBedIds"
								column-width="180px"
								@confirm="selectBeds"
								:isShowInput="false"
								:leafRowSelect="true"
								:classType="'DeanRecord'"
                :checkbox-icons="selectorCheckboxIcons"
                :confirm-button-style="confirmButtonStyle"
							>
								<template slot-scope="{isPanelOpen}">
									<div class="selected-tbg">
										<div class="selected-text">
											<span v-if="textShowContent&&textShowContent.length>12" class="contentItem">
												<span class="showContentItem">{{ textShowContent }}</span>
												<span class="contetnSufx">等{{selectedBedIds.length}}个床位</span>
											</span>
											<span v-else>{{ textShowContent }}</span>
										</div>
										<i class="arrow" :class="{ 'up': isPanelOpen }">
											<img src="@/assets/icon_common_special_arrow_9.png" alt="">
										</i>
									</div>
								</template>
							</CascadeSelector>
              <a-range-picker
                class="dean_record-picker timeChange"
								dropdownClassName="dean_record-picker_dropdown"
                format="YYYY-MM-DD"
								:allowClear="false"
                :disabled-date="disabledDate"
                :default-value="[
                  new Date()
                    .toLocaleDateString()
                    .replace('/', '-')
                    .replace('/', '-'),
                  new Date()
                    .toLocaleDateString()
                    .replace('/', '-')
                    .replace('/', '-'),
                ]"
                :placeholder="['开始时间', '结束时间']"
                @openChange="onOpenChange"
                @calendarChange="onCalendarChange"
                @change="onChangeTimer"
                inputReadOnly
                ><a-icon type="calendar" slot="suffixIcon"
              /></a-range-picker>
              <SingleLevelSelector
                classType="DeanRecord"
                :options="plainOptions"
                :value="checkedList"
                label-key="value"
                value-key="key"
                all-text="全部事件"
                empty-text="未选中事件"
                unit-text="类事件"
                :max-preview-length="12"
                :checkbox-icons="selectorCheckboxIcons"
                :confirm-button-style="confirmButtonStyle"
                @confirm="handleEventSelectorConfirm"
                style="margin-left: 15px;"
              />
            </div>
          </div>
        </div>
        <a-spin :spinning="spinning" tip="加载中" :delay="100">
          <div class="wirgin" v-if="!this.SocketBedInformation.length > 0">
            {{ bedInfo }}
          </div>
          <div
            class="BedInformation_contont hiddenScrollbar"
            v-else
            :id="BedInformation ? 'BedInformation_contonts' : ''"
          >
						<span class="history_info">历史信息</span>
            <div
              class="BedInformation_contont_text"
              v-for="(item, index) in SocketBedInformation"
              :key="index"
            >
              <span :class="item.isStress == 1 ? 'red' : ''">{{
                item.time
              }}</span>
              <span
								class="history_record_item_name"
                :class="item.isStress == 1 ? 'red' : ''"
                :style="{
                  display: item.name ? 'inline-block' : 'none',
                }"
                >{{ item.name ? item.name : "" }}</span
              >
              <div class="history_info_content" :class="item.isStress == 1 ? 'red' : ''" v-html="item.content"></div>
            </div>
          </div>
        </a-spin>
      </div>
      <br />
      <br />
      <br />
      <div class="dean_record_pagination">
        <a-pagination
          :defaultPageSize="20"
          :current="pageNum"
          :default-current="pageNum"
          :total="total"
          @change="onShowSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
const defaultCheckedList = [];
const defaultCheckedList1 = [];
import moment from "moment";
import "moment/locale/zh-cn";
import CascadeSelector from '../../component/common/CascadeSelector.vue';
import SingleLevelSelector from "../../component/common/SingleLevelSelector.vue";
import checkedIcon from '@/assets/img/CascadeSelector/allSel_1.png';
import indeterminateIcon from '@/assets/img/CascadeSelector/mulSel_1.png';
import uncheckedIcon from '@/assets/img/CascadeSelector/noSel.png';
export default {
  components: { CascadeSelector, SingleLevelSelector },
  data() {
    return {
      BedInformation: "BedInformations",
      SocketBedInformation: [], //最新消息床位
      checkedListType1: true,
      buttonTextType1: true,
      checkedListTex1: "",
      checkedList1: defaultCheckedList1,
      nullFunmsg1: false,
      indeterminate1: true,
      checkAll1: true,
      plainOptions1: [],
      checkedList: defaultCheckedList,
      plainOptions: [],
      dateString: [], //选择时间
      pageNum: 1, // 当前页
      total: 20,
      jiluZT: [],
      jiluZT1: [],
      spinning: true,
      bedInfo: "",

			textShowContent: '全部楼层',
			isSelectAllBedIds: true,
      selectedBedIds: [],
      cascadeData: [],

      selectedFloor: '',
      selectorCheckboxIcons: {
        checked: checkedIcon,
        indeterminate: indeterminateIcon,
        unchecked: uncheckedIcon
      },
      confirmButtonStyle: {
        background: 'rgba(74, 124, 232, 1)',
      }
    };
  },
  created() {},
  mounted() {
		this.getBedTreeData();
    this.checkedList = [];
    this.checkedList1 = [];
    this.getEventFilterOption();
    let time = new Date()
      .toLocaleDateString()
      .replace("/", "-")
      .replace("/", "-");
    this.dateString.push(time, time);
    console.log(this.dateString[0].split("-"), "this.dateString");
    setTimeout(() => {
      this.getbedChoice();
    }, 2000);
  },
  methods: {
		selectBeds(obj) {
			this.isSelectAllBedIds = obj.isSelectAll;
      this.selectedBedIds = obj.checkIds;
      this.textShowContent = obj.checkLabels.join('、');
			if (this.isSelectAllBedIds) {
				this.textShowContent = '全部楼层';
			}
			this.pageNum = 1;
      this.getbedChoice();
    },
		// 获取床位tree信息
    getBedTreeData() {
      this.$get(
        '/api/bed/treeList',
        { userId: this.$getCookie('userInfo').user.tenantId },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
							this.cascadeData = res.data.children ? JSON.parse(JSON.stringify(res.data.children)) : [];
              for (var i = 0; i < res.data.children.length; i++) {
                res.data.children[i].title =
                  res.data.children[i].title +
                  '（' +
                  res.data.children[i].value +
                  '床位）';
                if (res.data.children[i].children) {
                  for (
                    var n = 0;
                    n < res.data.children[i].children.length;
                    n++
                  ) {
                    res.data.children[i].children[n].title =
                      res.data.children[i].children[n].title +
                      '（' +
                      res.data.children[i].children[n].value +
                      '床位）';
                    for (
                      var k = 0;
                      k < res.data.children[i].children[n].children.length;
                      k++
                    ) {
                      res.data.children[i].children[n].children[k].title =
                        res.data.children[i].children[n].children[k].title +
                        '（' +
                        res.data.children[i].children[n].children[k].value +
                        '床位）';
                      for (
                        var j = 0;
                        j <
                        res.data.children[i].children[n].children[k].children
                          .length;
                        j++
                      ) {
                        // res.data.children[i].children[n].children[k].children[j].disabled = res.data.children[i].children[n].children[k].children[j].disabled;
                        // res.data.children[i].children[n].children[k].children[j].disabled = false;
                      }
                    }
                  }
                }
              }
							this.selectedBedIds = this.collectLeafIds(res.data.children);
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
		// 递归收集叶子节点id
		collectLeafIds(nodes) {
			const leafIds = [];
			nodes.forEach(node => {
				// 若为最后一层（无子节点），收集id
				if (!node.hasChildren) {
					leafIds.push(node.id);
				} else {
					// 否则递归处理子节点，合并结果
					leafIds.push(...this.collectLeafIds(node.children));
				}
			});
			return leafIds ? leafIds.map(String) : [];
		},
    /**
     * 清空禁用时间段的设置
     */
    onOpenChange(status) {
      // 清空禁用时间段的设置
      this.disabledCurrent = null;
    },
    /**
     * 获取手动选择的时间段起始值
     */
    onCalendarChange(dates) {
      console.log("From: ", dates[0], ", to: ", dates[1]);
      // 获取手动选择的时间段起始值
      this.disabledCurrent = dates[0];
    },
    /**
     * 时间控制切换赋值
     */
    onChangeTimer(moment, data) {
      //this.fromTime = data[0];
      //this.toTime = data[1];
      this.dateString = data;
      this.pageNum = 1;
      this.getbedChoice();
    },
    /**
     * 1、时间限制范围 开始时间~结束时间不能超过31天
     */
    disabledDate(current) {
      if (!this.disabledCurrent) return current > moment().startOf(1, "day");

      return (
        (current && current > moment().startOf(1, "day")) ||
        current <
          moment(this.disabledCurrent).subtract(1, "M").startOf("day") ||
        current > moment(this.disabledCurrent).add(1, "M").endOf("day")
      );
    },
    lllChange(e) {
      console.log(e, "eeeee");
      // this.indeterminate1=true;
      if (this.checkAll1) {
        this.checkAll1 = false;
        this.checkedList1 = [];
      } else {
        this.checkAll1 = true;
        this.checkedList1 = [];
        this.plainOptions1.forEach((item) => {
          //事件类型默认全选
          this.checkedList1.push(item.bedId);
        });
      }
    },
    bedChoice() {
      //选择床位确定事件
      if (this.dateString.length < 1) {
        this.$message.error("请选择时间范围！！！");
        return;
      }
      this.nullFunmsg1 = false;
      let text = [];
      if (this.plainOptions1 && this.plainOptions1.length > 1) {
        this.plainOptions1.forEach((item) => {
          this.checkedList1.forEach((i) => {
            if (item.bedId == i) {
              text.push(item.bedName);
            }
          });
        });
        this.checkedListTex1 = JSON.stringify(text).split("[")[1].split("]")[0];
      } else if (this.plainOptions1 && this.plainOptions1.length == 1) {
        this.checkedListTex1 = this.plainOptions1[0].bedName;
      }

      if (this.checkedList1.length == this.plainOptions1.length) {
        this.buttonTextType1 = true;
        this.checkedListType1 = true;
      } else if (this.checkedList1.length == 0) {
        this.buttonTextType1 = false;
        this.checkedListType1 = true;
      } else if (
        this.checkedList1.length > 0 &&
        this.checkedList1.length != this.plainOptions1.length
      ) {
        this.checkedListType1 = false;
      }

      this.jiluZT1 = JSON.parse(JSON.stringify(this.checkedList1));
	  this.pageNum = 1;
      this.getbedChoice();
    },
    bedChoiceErr() {
      //取消选择床位
      this.checkedList1 = this.jiluZT1;
      this.nullFunmsg1 = false;
      // this.checkedList1=this.jiluZT1;
      // this.indeterminate1 = false;
      // this.checkedListType1 = true;
      // this.checkAll1 = false;
      // this.buttonTextType1 = false;
      // this.getbedChoice();
    },
    getNull1() {
      //清空事件
      this.checkedList1 = [];
      // this.indeterminate1 = false;
      // this.checkAll1 = false;
      // this.buttonTextType1 = false;
    },
    getbedChoice() {
      if (this.dateString.length < 1 || this.dateString[0] == "") {
        this.$message.error("请选择时间范围！！！");
        return;
      }
      this.spinning = true;
      console.log(
        this.checkedList1.length,
        this.checkedList1,
        this.checkedList,
        this.SocketBedInformation,
        "444444"
      );
      // //选择床位或选择类型之后请求接口
      // let bedIds = "";
      // // this.checkedList1.length > 0
      // //   ? JSON.stringify(this.checkedList1).split("[")[1].split("]")[0]
      // //   : 0; //选择床位id
      // if (this.checkedList1.length == this.plainOptions1.length) {
      //   bedIds = "";
      // } else if (
      //   this.checkedList1.length > 0 &&
      //   this.checkedList1.length != this.plainOptions1.length
      // ) {
      //   bedIds = JSON.stringify(this.checkedList1).split("[")[1].split("]")[0];
      // } else if (this.checkedList1.length == 0) {
      //   bedIds = 0;
      // }

			// bedIds: ""为全选 | 0为全不选 | 其他
			let bedIds = "";
			if (!this.isSelectAllBedIds) {
				let tempSelectedBedIds = this.selectedBedIds ? JSON.parse(JSON.stringify(this.selectedBedIds)) : null;
				bedIds = tempSelectedBedIds.join(',');
			}

      let a = null;
      if (this.dateString[0].split("-")[1].length < 2) {
        a = "0" + this.dateString[0].split("-")[1];
      } else {
        a = this.dateString[0].split("-")[1];
      }
      let b = null;
      if (this.dateString[0].split("-")[2].length < 2) {
        b = "0" + this.dateString[0].split("-")[2];
      } else {
        b = this.dateString[0].split("-")[2];
      }
      let a1 = null;
      if (this.dateString[1].split("-")[1].length < 2) {
        a1 = "0" + this.dateString[1].split("-")[1];
      } else {
        a1 = this.dateString[1].split("-")[1];
      }
      let b1 = null;
      if (this.dateString[1].split("-")[2].length < 2) {
        b1 = "0" + this.dateString[1].split("-")[2];
      } else {
        b1 = this.dateString[1].split("-")[2];
      }
      let endDate = this.dateString[1].split("-")[0] + "-" + a1 + "-" + b1; //结束时间
      let pageNum = this.pageNum;
      let pageSize = 20;
      let startDate = this.dateString[0].split("-")[0] + "-" + a + "-" + b; //开始时间
      let typeIds = "";
      // this.checkedList.length > 0
      //   ? JSON.stringify(this.checkedList).split("[")[1].split("]")[0]
      //   : '';
      if (this.checkedList.length == this.plainOptions.length) {
        typeIds = "";
      } else if (
        this.checkedList.length > 0 &&
        this.checkedList.length != this.plainOptions.length
      ) {
        typeIds = JSON.stringify(this.checkedList).split("[")[1].split("]")[0];
      } else if (this.checkedList.length == 0) {
        typeIds = 0;
      }

      this.$get(
        "/api/event/search?bedIds=" +
          bedIds +
          "&endDate=" +
          endDate +
          "&startDate=" +
          startDate +
          "&pageNum=" +
          pageNum +
          "&pageSize=" +
          pageSize +
          "&typeIds=" +
          typeIds,
        "",
        (res) => {
          this.spinning = false;
          this.total = res.data.total;
          if (res.data.records && res.data.records.length > 0) {
            this.SocketBedInformation = res.data.records;
            this.bedInfo = "";
          } else {
            this.SocketBedInformation = [];
            this.bedInfo = "暂无床位信息";
          }
        },
        (err) => {
          this.spinning = false;
          this.bedInfo = "";
          console.log(err);
        }
      );
    },
    onChanges1(checkedList) {
      this.indeterminate1 =
        !!checkedList.length && checkedList.length < this.plainOptions1.length;
      this.checkAll1 = checkedList.length === this.plainOptions1.length;
      //console.log(this.checkAll1, checkedList);
    },
    getEventFilterOption() {
      console.log(this.checkedList, "checkedList");
      //获取事件类型
      this.$get(
        "/api/event/eventFilterOption",
        "",
        (res) => {
          if (!res.data) {
            return;
          }
          this.plainOptions = res.data;
          console.log(this.checkedList, res, "checkedList");
          res.data.forEach((item) => {
            //事件类型默认全选
            this.checkedList.push(item.key);
            console.log(this.checkedList, "checkedList");
          });
          this.jiluZT = JSON.parse(JSON.stringify(this.checkedList));
        },
        (err) => {
          console.log(err);
        }
      );
      this.$get(
        "/api/bed/nameList",
        "",
        (res) => {
          if (!res.data) {
            return;
          }
          this.plainOptions1 = res.data;

          console.log(res.data, "this.plainOptions1");
          res.data.forEach((item) => {
            //事件类型默认全选
            this.checkedList1.push(item.bedId);
          });
          this.jiluZT1 = JSON.parse(JSON.stringify(this.checkedList1));
        },
        (err) => {
          console.log(err);
        }
      );
    },
    handleEventSelectorConfirm(payload = {}) {
      if (!this.dateString || this.dateString.length < 1) {
        this.$message.error("请选择时间范围！！！");
        return;
      }

      const values = Array.isArray(payload.values) ? payload.values : [];
      this.checkedList = values;
      this.jiluZT = JSON.parse(JSON.stringify(this.checkedList));
      this.pageNum = 1;
      this.getbedChoice();
    },
    onChange(date, dateString) {
      let sDate1 = Date.parse(dateString[0]);
      let sDate2 = Date.parse(dateString[1]);
      let dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      let iDays = Math.floor(dateSpan / (24 * 3600 * 1000));

      if (iDays > 31) {
        this.$message.error("所选时间间隔不得超过31天！！！");
        return;
      }
      this.dateString = dateString;
      this.getbedChoice();
      console.log(date, this.dateString.length, iDays, dateString, "111111");
    },
    onShowSizeChange(e) {
      console.log(e);
      this.pageNum = e;
      this.getbedChoice();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .selector-trigger {
  max-width: 220px;
  height: 40px;
  text-align: center;
  background: rgba(74,124,232,0.1);
  border-radius: 80px;
  border: 1px solid rgba(74,124,232,0.3) !important;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #4A7CE8;
	padding-left: 15px;
	padding-right: 15px;
}
::v-deep .selected-tags .selected-tags {
  gap: 0;
}

.selected-tbg {
  display: flex;
  align-items: center;
  .arrow {
    font-size: 12px;
    color: #666;
    transition: transform 0.2s;
    line-height: 1;
		margin-left: 5px;
		img {
			width: 14px;
			height: 14px;
		}
  }
  .arrow.up {
    transform: rotate(180deg);
  }
}
.selected-text {
  flex: 1;
  max-width: 180px;
}

.contentItem {
  position: relative;
	display: flex;
	align-items: center;
}

.showContentItem {
  display: inline-block;
  width: 85px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.contetnSufx {
  position: relative;
	white-space: nowrap;
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #4A7CE8;
	line-height: 20px;
}

.hiddenScrollbar::-webkit-scrollbar {
	display: none
}

.history_record_item_name {
	margin-right: 30px;
	width: auto !important;
}

</style>
<style lang="scss">
.main {
  width: 100%;
  height: 100%;
}
.BedInformationRecord {
  width: 100%;
  height: 100%;
  margin-top: 20px;
  padding-bottom: 40px;
  .BedInformation_box {
    width: 1205px;
    margin: auto;
    border-radius: 8px;
    padding: 20px;
		background: rgba(236, 240, 243, 1);
		box-shadow: 10px 10px 30px 0px #D1D9E6, -10px -10px 30px 0px #FFFFFF;
		border-radius: 20px;
		height: 700px;
    .BedInformation_title {
      width: 100%;
			margin-bottom: 15px;
      .BedInformation_title_ {
        display: flex;
        align-items: center;
        width: 1180px;
        margin: auto;
      }
      .BedInformation_button {
        display: flex;
        align-items: center;
        .spannone {
          //  width: 90px;
          padding: 0 10px 0 10px;
          height: 32px;
          background: #e6f7ff;
          border-radius: 2px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #1890ff;
          margin-left: 10px;
          cursor: pointer;
          position: relative;
          #nb {
            span:first-child {
              width: 150px !important;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .spannone1 {
            display: flex;
            span:first-child {
              width: 80px;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
		  
          .spannoneDiv1 {
            position: absolute;
            width: 920px;
            height: 219px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            overflow: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            // justify-content: space-between;
            padding: 5px 12px 5px 12px;
            z-index: 10;
            .butt {
              width: 98%;
              position: absolute;
              bottom: 0;
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              padding-bottom: 10px;
              button {
                margin-right: 10px;
              }
            }
            .ant-checkbox-wrapper {
              // width: 100%;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }
            .ant-checkbox-group {
              display: flex;
              // flex-direction:column;
              flex-wrap: wrap;
              align-items: flex-start;
              width: 100%;
              max-height: 250px;
              overflow: auto;
              .ant-col {
                margin-top: 10px;
              }
            }
          }
        }
				.spannoneNew {
          display: flex;
          position: relative;
          #nb {
            span:first-child {
              width: 150px !important;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .spannone1 {
            display: flex;
            span:first-child {
              width: 80px;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
		  
          .dean_record-spannoneDiv {
            width: 250px;
            border-radius: 2px;
            overflow: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 5px 5px 5px 5px;
            z-index: 10;
						.dean_record-spannoneDiv-all {
							display: flex;
							justify-content: space-between;
							align-items: center;
							width: 100%;
							height: 40px;
							background: red;
							padding-left: 8px;
							padding-right: 8px;
						}
            .butt {
              width: 90%;
              position: absolute;
              bottom: 0;
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              padding-bottom: 10px;
              button {
                margin-right: 10px;
              }
            }
            .ant-checkbox-group {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              width: 100%;
              padding-bottom: 60px;
              .ant-col {
                margin-top: 10px;
              }
            }
						.dean_record-main-a-checkbox {
							border: unset;
							.ant-checkbox-indeterminate .ant-checkbox-inner::after {
								height: 1px;
							}
							.ant-checkbox {
								.ant-checkbox-inner {
									border: 1px solid rgb(88, 89, 90);
									border-radius: 50%;
								}
							}
							// 半选
							.ant-checkbox-indeterminate {
								.ant-checkbox-inner {
									background: rgb(74, 124, 232);
									border: unset;
								}
								.ant-checkbox-inner::after {
									background: #fff;
									border: unset;
								}
							}
							// 全选
							.ant-checkbox-checked {
								.ant-checkbox-inner {
									background: rgb(74, 124, 232);
									border: unset;
								}
							}
							.ant-checkbox-checked::after {
								border: unset;
							}

						}
						.dean_record-sub-a-checkbox {
							.ant-checkbox + span {
								padding-left: 5px;
								padding-right: 5px;
							}
							.ant-checkbox-inner {
								border: 1px solid rgba(88, 89, 90, 1);
								border-radius: 50%;
							}
							.ant-checkbox-checked .ant-checkbox-inner {
								background: rgba(74, 124, 232, 1);
								border: unset;
								border-radius: 50%;
							}
							.ant-checkbox-indeterminate .ant-checkbox-inner {
								border-color: rgba(74, 124, 232, 1);
							}
							.ant-checkbox-checked::after {
								border: unset;
							}
						}
          }
          .spannoneDiv1 {
            position: absolute;
            width: 920px;
            height: 219px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            overflow: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            // justify-content: space-between;
            padding: 5px 12px 5px 12px;
            z-index: 10;
            .butt {
              width: 98%;
              position: absolute;
              bottom: 0;
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              padding-bottom: 10px;
              button {
                margin-right: 10px;
              }
            }
            .ant-checkbox-wrapper {
              // width: 100%;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }
            .ant-checkbox-group {
              display: flex;
              // flex-direction:column;
              flex-wrap: wrap;
              align-items: flex-start;
              width: 100%;
              max-height: 250px;
              overflow: auto;
              .ant-col {
                margin-top: 10px;
              }
            }
          }
        }
        .timeChange {
					margin-right: 0px;
          width: 240px !important;
          height: 40px;
          margin-left: 15px;
          background: rgba(74, 124, 232, 0.10) !important;
					border-radius: 20px;
					display: flex;
					align-items: center;
					border: 1px solid rgba(74, 124, 232, 0.30);
          span,
          input,
          input::-webkit-input-placeholder,
          .ant-calendar-range-picker-input {
            color: rgba(74, 124, 232, 1) !important;
            background: rgba(74, 124, 232, 0) !important;
            border: none !important;
          }
					.anticon svg {
						color: rgba(74, 124, 232, 1) !important;
					}
					.ant-input {
						box-shadow: unset;
					}
        }
      }
      .looknone1 {
        font-size: 18px;
        font-weight: 500;
        color: #262626;
      }
      .looknone {
        font-size: 14px;
        font-weight: 400;
        color: #1890ff;
        margin-left: 10px;
        line-height: 24px;
        cursor: pointer;
      }
    }
    .wirgin {
      font-size: 14px;
      font-weight: 400;
      color: #262626;
			height: 555px;
    }
    .BedInformation_contont {
      width: 100%;
			height: 555px;
      padding-bottom: 10px;
			overflow-y: scroll;
			background: rgba(255,255,255,0.5);
			border-radius: 8px;
			border: 1px solid rgba(255,255,255,0.9);
			padding-left: 15px;
			display: flex;
			flex-direction: column;

			.history_info {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #A4ABB6;
				line-height: 20px;
				margin-top: 15px;
			}

      .BedInformation_contont_text {
        width: 100%;
        display: flex;
        margin-top: 12.5px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #5E6779;
				line-height: 19px;
        .red {
          color: rgba(255, 113, 134, 1) !important;
        }
        span {
          margin-left: 30px;
          font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #5E6779;
					line-height: 19px;
        }
        span:nth-child(2) {
          width: 214px;
        }
        span:nth-child(3) {
          // width: 870px;
        }
        span:first-child {
          margin-left: 0;
          width: 180px;
        }
				.history_info_content {
					margin-left: 15px;
				}
      }
    }
  }
	.dean_record_pagination {
    position: fixed;
    top: 750px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
		
		 // 分页样式穿透
		.ant-pagination-item {
			background: #ECF0F3;
			box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
			border-radius: 8px;
			border: 1px solid #ECF0F3;

			&:hover {
				background: #DFE8FC;
				border-color: #DFE8FC;
			}

			&.ant-pagination-item-active {
				border-color: rgba(74, 124, 232, 0.5);
			}
		}

		.ant-pagination-item-link {
			background: #ECF0F3;
			box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
			border-radius: 8px;
			border: none;

			&:hover {
				background: #DFE8FC;
				border-color: #DFE8FC;
			}

			&.ant-pagination-disabled {
				background: #ECF0F3;
				border: 1px solid rgba(202, 205, 217, 0.5);
				box-shadow: none;
			}
		}
  }
}

.dean_record-picker_dropdown {
	top: 170px !important;
	.ant-calendar-input-wrap {
		display: none;
	}
	.ant-calendar {
		box-shadow: 0 4px 16px rgba(94, 103, 121, 0.15);
		border: none;
		border-radius: 8px;
	}
	thead th {
		color: rgba(94, 103, 121, 0.5);
	}
	.ant-calendar-body {
		border-top: 1px solid #EBEEF5;
	}
	.ant-calendar-today .ant-calendar-date {
		color: rgba(0, 0, 0, 0.65);
		border: unset;
		font-weight: 400;
	}
	.ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date, .ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date, .ant-calendar-range .ant-calendar-selected-middle-date .ant-calendar-date {
		background: rgb(74, 124, 232);
		border-radius: 50%;
		color: #fff;
	}
	.ant-calendar-range .ant-calendar-in-range-cell::before {
		background: rgba(74, 124, 232, 0.2);
	}
	.ant-calendar-disabled-cell .ant-calendar-date {
		background: #ffffff00;
	}
}

.dean_record_pagination {
	.ant-pagination-item-active:focus a, .ant-pagination-item-active:hover a {
		color: rgba(74, 124, 232, 1);
	}
	.ant-pagination-item-active a {
		color: rgba(74, 124, 232, 1);
	}
	.ant-pagination-item:focus a, .ant-pagination-item:hover a {
		color: rgba(74, 124, 232, 1);
	}
	.ant-pagination-item.ant-pagination-item-active {
    border-color: rgba(74, 124, 232, 0.50);
	}
}
</style>